import React from "react";
import { CONTENT_TYPE, STREET_ID, WITH_PARENT } from "../../constants/fiasAPI";

import Asynchronous from "./Asynchronous/Asynchronous";
import { AsynchronousProps } from "../../types/common";
import { getGeoCode } from "../../api/yaGeocoderAPI";
import { GEOCODE } from "../../constants/yaGeocoderAPI";
import { ItemData } from "../../types/api/fiasAPI";
import { YaGeoCodeResponse } from "../../types/api/yaGeocoderAPI";

interface Props extends Omit<AsynchronousProps, "onChange"> {
    streetId: string;
    onChange: (value: string) => void;
}

const BuildingSelect = ({ onChange, value, field, error, callbackResult, streetId, disabled }: Props) => {
    const getCoordinates = (selectValue: ItemData) => {
        const query = "";
        // selectValue.parents?.reduce((str: string, curStr: ItemData) => str.concat(" ", curStr.name), "") +
        // " " +
        // selectValue.name;
        // getGeoCode(
        //     ({
        //         response: {
        //             GeoObjectCollection: { featureMember },
        //         },
        //     }: YaGeoCodeResponse) => {
        //         const modifyValue = {
        //             ...selectValue,
        //             coords: JSON.stringify(featureMember[0].GeoObject.Point.pos.split(" ").reverse()),
        //         };
        //         callbackResult && callbackResult(modifyValue);
        //     },
        //     err => {
        //         console.log(err);
        //     },
        //     {
        //         [GEOCODE]: query,
        //     },
        // );
    };
    return (
        <Asynchronous
            onChange={item => {
                onChange(
                    `${item?.data?.house_type ?? ""} ${item?.data?.house ?? ""} ${item?.data?.block_type ?? ""} ${
                        item?.data?.block ?? ""
                    }`,
                );
            }}
            getParam="house"
            locations={[{ fias_id: streetId }]}
            value={value}
            label={"Дом"}
            error={error}
            callbackResult={callbackResult}
            from_bound={{ value: "house" }}
            to_bound={{ value: "house" }}
            disabled={disabled}
            // searchParams={{ [CONTENT_TYPE]: "building", [STREET_ID]: streetId, [WITH_PARENT]: 1 }}
        />
    );
};

export default BuildingSelect;
